module.exports = __webpack_public_path__ + "media/ludwig.09e13e01.wav";